import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Input, TextArea } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
import { Dropdown } from "primereact/dropdown";
import { Col, Grid, Row } from "@vds/grids";
import { Button } from "@vds/buttons";
import { Spacer, CompactCol } from "../../components/core/utility";
import { CommonValidateAddress } from "../C4S Decommission - Replacement/CommonValidateAddress";
import {
  getMaterialMappings,
  getReasons,
  updateHardware,
  uploadImage,
  retrieveBundleFiles,
  getExistingHardwareRequest,
  createHardwareRequest,
  updateHardwareRequest,
} from "../../services/C4S Decommission - Replacement/editVehicleWTA";
import { Loader } from "@vds/loaders";
import { BADGE_STYLE, BUNDLE_LIST, HARDWARE_REQUEST_STATUS, HARDWARE_REQUEST_STATUS_CONSTANT } from "./EditVehicleConstants";
import { PrivilegeContext } from "../../../context/privilegeContext";
import { getStatesList } from "../../services/C4S Decommission - Replacement/getStatesList";
import { getCountryList } from "../../services/scheduler/getCountryList";
import { Notification } from "@vds/notifications";
import { generate } from "shortid";
import { groupBy, isEqual } from "lodash";
import { handleChangePage, switchTab } from "./../C4S Decommission - Replacement/utils";
import { Icon } from "@vds/icons";
import VehicleImageUpload from "./../../components/core/CustomUploadFile/CustomUploadFile";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { ViewVehicleList } from "../../services/C4S Decommission - Replacement/viewVehicleList";
import { messageBus } from "../../../../src/utility/messageBus";
import AddMaterial from "./AddMaterial";
import { getContractDetails } from "../../services/C4S Decommission - Replacement/getMMIDList";
import styled from "styled-components";
import "./EditVehicleWTAComponent.css";
import ClearRequestConfirmationModal from "./ClearRequestConfirmationModal";
import VehicleChangeModal from "./VehicleChangeModal";

export const CustomisedDropdown = styled(Dropdown)`
  border: 1px solid #6f7171 !important;
  font-family: Verizon-NHG-eTX;
  width: 100%;
  box-shadow: none !important;
  font-size: 16px !important;
  color: #000000 !important;
`;

const StyledCheckbox = styled(Input)`
  margin-top: 0.5rem;
  font-weight: 100;
  font-size: 14px !important;
`;

const StyledDontShipCheckbox = styled(Input)`
  font-size: 12px;
  margin-top: 20px;
  margin-right: 7px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledDontShipCheckboxHidden = styled(Input)`
  font-size: 12px;
  margin-top: 20px;
  margin-right: 7px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  pointer-events: none;
`;

const { MODIFIED, MODIFIED_PENDING_AGENT, REVERTED_PENDING_AGENT, REVERTED, APPROVED, CLEARED, CREATED } = HARDWARE_REQUEST_STATUS_CONSTANT;

const isClosedLineItem = (materialObj) => {
  return materialObj.status?.toLowerCase() === "submitted";
};

const buildDontShipCheckboxState = (materialMapping) => {
  if (!materialMapping?.length) {
    return {};
  }

  return materialMapping.reduce((acc, item) => {
    if (item?.id !== undefined) {
      acc[item.id] = Boolean(item.isShipmentHold);
    }
    return acc;
  }, {});
};

const EditVehicleWTAComponent = ({ data, bundleName, bundleId, bundleData, setModalOpened, assetType }) => {
  const origData = useRef({ ...data, materialMapping: [...data.materialMapping] });
  const [vehicleDetails, setVehicleDetails] = useState({
    ...data,
    materialMapping: data.materialMapping.map((item) => {
      return {
        ...item,
        materials: [{ materialId: item.hardwareId, materialName: item.hardwareName }],
      };
    }),
  });
  const { cspInfo, setAlertModal } = useContext(PrivilegeContext);
  const [reasonSelected, setReasonSelected] = useState(data.reason || null);
  const reasonForNonPriority1Ref = useRef(null);
  const [notification, setNotification] = useState(null);
  const notificationTimeoutRef = useRef(null);
  const notificationInteractionRef = useRef(false);
  const defaultPriority = data.priority || 1;
  const [materialsAndPriorities, setMaterialsAndPriorities] = useState();
  const [hardwareSelected, setHardwareSelected] = useState(null);
  const [contact, setContact] = useState(data.contact);
  const [email, setEmail] = useState(data.email);
  const [phone, setPhone] = useState(data.phone);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneErrorText, setPhoneErrorText] = useState("");
  const [vehicleData, setVehicleData] = useState([]);
  const [hardwares, setHardwares] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [commentText, setCommentText] = useState(data.comment);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [isFieldsChanged, setIsFieldsChanged] = useState(false);
  const [originalFormValues, setOriginalFormValues] = useState(null);
  const [isCriticalFieldsChanged, setIsCriticalFieldsChanged] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hardwareRequestInitiated, setHardwareRequestInitiated] = useState(false);
  const [requestedHardwareFromDropdown, setRequestedHardwareFromDropdown] = useState({});
  const [reasonForChangingRecommendation, setReasonForChangingRecommendation] = useState("");
  const [hardwareChangeComment, setHardwareChangeComment] = useState("");
  const [isAddMaterialModalOpen, setIsAddMaterialModalOpen] = useState(false);
  const [existingHardwareRequest, setExistingHardwareRequest] = useState(null);
  const [addedMaterials, setAddedMaterials] = useState([]);
  const [isRequestedHardwareChanged, setIsRequestedHardwareChanged] = useState(false);
  const [requestedMaterialList, setRequestedMaterialList] = useState({});
  const [isStartRequestDisabled, setIsStartRequestDisabled] = useState(
    vehicleDetails.materialMapping.every((item) => item.status?.toLowerCase() === "submitted")
  ); //button disabled when material status is submitted
  const [doNotShipCheckboxSelected, setDoNotShipCheckboxSelected] = useState(!!data?.isShippingBlocked);
  const [selectedHardwareSpecifier, setSelectedHardwareSpecifier] = useState(null);
  const [showClearRequestModal, setShowClearRequestModal] = useState(false);
  const [noRecommendationSubscription, setNoRecommendationSubscription] = useState([]);
  const [showChangeVehicleModal, setShowChangeVehicleModal] = useState(false);
  const [isDoNotShipChanged, setIsDoNotShipChanged] = useState(false);
  const [isDontShipFromHardware, setIsDontShipFromHardware] = useState(buildDontShipCheckboxState(vehicleDetails.materialMapping));

  useEffect(() => {
    // Sync checkbox with incoming prop if it changes
    if (typeof vehicleDetails?.isShippingBlocked !== "undefined") {
      setDoNotShipCheckboxSelected(!!vehicleDetails.isShippingBlocked);
    }
  }, [vehicleDetails?.isShippingBlocked]);

  //Dont ship check box for each material line item
  useEffect(() => {
    setIsDontShipFromHardware(buildDontShipCheckboxState(vehicleDetails.materialMapping));
  }, [vehicleDetails.materialMapping]);
  // Helper function to check if there are no valid recommendations
  const hasNoValidRecommendations = () => {
    return !hardwares || hardwares.length === 0;
  };

  const handleFileUpload = async (files) => {
    const vehicleId = data.vehicle;
    // Check if 'files' is indeed an array, and iterate over it
    if (!Array.isArray(files)) {
      // If only a single file is passed, wrap it in an array for consistent processing
      files = [files];
    }

    for (const file of files) {
      // Iterate over each individual file
      // Ensure file.name exists before using it in the URL
      if (!file || !file.name) {
        continue; // Skip to the next file if this one is invalid
      }

      try {
        // Call the uploadImage service function with the correct parameters:
        // vehicleId, bundleId, and the actual file object.
        const response = await uploadImage(vehicleId, bundleId, file);

        if (response.status >= 200 && response.status < 300) {
          // Check for success status codes (2xx)
          // eslint-disable-next-line
        } else {
          // eslint-disable-next-line
        }
      } catch (error) {
        // Catch network errors or errors re-thrown from the service function
        // eslint-disable-next-line
        // setHasImages(false); // Adjust based on your error handling for multiple files
      }
    }
  };
  const prepareHardwareApiPayload = (veh = vehicleDetails) => {
    if (!cspInfo?.data?.data) return null;

    const cspData = cspInfo.data.data;
    const products = cspData.Product || [];

    const coreProducts = products.filter(
      (product) => product.BundleId === bundleId && product.featureType === "CORE" && product.AssetType.toLowerCase() === assetType.toLowerCase()
    );

    if (!coreProducts.length) return null;

    const payload = {
      vinList: [
        {
          id: veh.id,
          vin: veh.vehicle,
          year: veh.year,
          make: veh.make,
          model: veh.model,
          killSwitch: veh.killSwitch,
          emergency: veh.emergency,
          wheelChair: veh.wheelChair,
          weightClass: veh.weightClass,
          fuelType: veh.fuelType,
        },
      ],
      type: veh.vehicle.startsWith("VIN") ? "YMM" : veh.vehicle.startsWith("AST") ? "ASSET" : "VEHICLE",
      countryCode: cspData.BillingCountry,
      salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
      productPlatform: cspData.ProductPlatform,
      accountBrand: cspData.Account_Brand,
      createdBy: `${cspData?.firstName} ${cspData?.lastName}`,
      vehicleSubscriptions: [],
    };
    const subscriptions = {};

    coreProducts.forEach((product) => {
      const subscription = product.SAPProductID;
      const techRefId = product.TechRefId;

      if (!subscriptions[subscription]) {
        subscriptions[subscription] = {
          subscription,
          techRefId,
          vehicleFeatures: [],
        };
      }

      const features = products.filter(
        (p) => p.BundleId === product.BundleId && p.featureType === "FEATURE" && p.AssetType.toLowerCase() === assetType.toLowerCase()
      );

      features.forEach((feature) => {
        subscriptions[subscription].vehicleFeatures.push({
          materialId: feature.SAPProductID,
          techRefId: feature.TechRefId,
        });
      });
    });

    payload.vehicleSubscriptions = Object.values(subscriptions);
    return payload;
  };

  const assignHardwareToHardwareSpecifierMapCreation = useCallback(
    (materialMapping) => {
      const deviceData =
        assetType === "Asset" ? materialsAndPriorities[0] : materialsAndPriorities?.find((device) => device?.deviceType === hardwareSelected);

      // Embed deviceType into all recommendations at the source
      const firstDeviceData = deviceData
        ? {
            ...deviceData,
            recommendations: (deviceData.recommendations || []).map((rec) => ({
              ...rec,
              deviceType: deviceData.deviceType,
            })),
          }
        : null;

      let listOfNoRecommendationSubscription = [];
      const groupBySubscriptionId = groupBy(materialMapping, "subscriptionId");
      const assignHardwareToHardwareSpecifierMap = materialMapping?.length
        ? Object.keys(groupBySubscriptionId).reduce((acc, key) => {
            const listOfsubscriptions = groupBySubscriptionId[key];
            const recommendations = firstDeviceData?.recommendations.filter((e) => e?.subscriptionId === key);
            const available = recommendations ? [...recommendations] : [];

            if (available.length === 0) {
              listOfNoRecommendationSubscription.push(key);
            }

            const matchType = (rec, subType) => String(rec?.materials?.[0]?.type || "").toLowerCase() === String(subType || "").toLowerCase();

            listOfsubscriptions?.forEach((subItems) => {
              // Use each recommendation at most once
              const idx = available.findIndex((r) => matchType(r, subItems?.subType));
              if (idx !== -1) {
                const matchingRecommendation = available.splice(idx, 1)[0];

                acc[subItems.id] = {
                  ...matchingRecommendation,
                  ...(matchingRecommendation.isActionable
                    ? { selectedMaterialId: matchingRecommendation.materials[0].materialId, selectedMaterial: matchingRecommendation.materials[0] }
                    : {}),
                };
              }
            });
            return acc;
          }, {})
        : null;

      setSelectedHardwareSpecifier(assignHardwareToHardwareSpecifierMap);
      setNoRecommendationSubscription(listOfNoRecommendationSubscription);
    },
    [assetType, materialsAndPriorities, hardwareSelected]
  );

  const processMaterialResponse = (materialResponse) => {
    const partRecommendationResponse = materialResponse?.data?.data.map((entry) => {
      return {
        ...entry,
        recommendations: entry?.recommendations?.map((rec, index) => ({
          ...rec,
          id: generate(), // Generate a unique ID for each recommendation
        })),
      };
    });

    let hardwareList = [];
    if (materialResponse?.data?.data && materialResponse.data.data.length > 0) {
      const hasPriorityZero = materialResponse.data.data.some((device) => device.priority === "0" || device.priority === 0);

      if (hasPriorityZero) {
        hardwareList = [];
      } else {
        hardwareList =
          materialResponse.data.data && materialResponse.data.data.length && materialResponse.data.data[0].priority
            ? materialResponse.data.data
                .map((device, index) => ({
                  id: index + 1,
                  value: device.deviceType,
                  label: `${device.deviceType} (Priority: ${device.priority || "1"})`,
                  priority: device.priority ? parseInt(device.priority, 10) : 1,
                }))
                .sort((a, b) => a.priority - b.priority)
            : [];
      }

      const priorityToMatch = parseInt(vehicleDetails.priority || defaultPriority, 10);
      const matchingHardware = hardwareList.find((h) => h.priority === priorityToMatch);
      let selectedHardware;
      if (matchingHardware && data.vehicleStatus !== "Warning") {
        selectedHardware = matchingHardware.value;
      } else if (hardwareList.length > 0) {
        selectedHardware = hardwareList[0].value;
      }
      return { partRecommendationResponse, hardwareList, selectedHardware };
    }

    return {};
  };

  useEffect(() => {
    const fetchHardwares = async () => {
      try {
        setIsLoading(true);
        setIsTableLoading(true);
        const reasonsResponse = await getReasons("RECOMM_CHANGE_REASONS");
        const existingHardware = await getExistingHardwareRequest(data.id);
        const materialResponse = await getMaterialMappings(prepareHardwareApiPayload());
        const countriesResponse = await getCountryList();
        const statesResponse = await getStatesList();

        let requestEntry = existingHardware?.data?.data?.requests?.find((e) => e.status.toLowerCase() !== "cancelled");
        if (requestEntry?.status === CLEARED) {
          setExistingHardwareRequest(null);
          requestEntry = null;
        } else setExistingHardwareRequest(requestEntry || null);

        if (requestEntry) {
          setHardwareRequestInitiated(true);
          setReasonForChangingRecommendation(requestEntry.reasonForChange || "");
          setHardwareChangeComment(requestEntry.deploymentAgentComments || "");
        }

        const { partRecommendationResponse, hardwareList = [], selectedHardware = null } = processMaterialResponse(materialResponse);

        setMaterialsAndPriorities(partRecommendationResponse);
        setHardwares(hardwareList);
        setHardwareSelected(selectedHardware);

        if (reasonsResponse?.data) {
          const reasonsList = reasonsResponse.data.data.map((reason) => ({
            id: reason.id,
            value: reason.id,
            label: reason.description,
          }));
          setReasons(reasonsList);
          if (data.reason) {
            const matchingReason = reasonsList.find((r) => r.id === data.reason || r.value === data.reason);
            if (matchingReason) {
              setReasonSelected(matchingReason.value);
            }
          }
        }
        if (countriesResponse?.data?.data) {
          setAddress((prevState) => ({
            ...prevState,
            country: {
              ...prevState.country,
              options: countriesResponse.data.data,
            },
          }));
        }

        if (statesResponse?.data?.data) {
          let allStateOptions = statesResponse.data.data.map((state) => ({
            ...state,
            stateName: state.erpStateCode + " - " + state.stateCode,
          }));
          const groupedStateOptions = groupBy(allStateOptions, "countryCode");

          setAddress((prevState) => ({
            ...prevState,
            state: {
              ...prevState.state,
              allStateOptions: groupedStateOptions,
              options: groupedStateOptions["USA"],
            },
          }));
        }
      } catch (error) {
        // error handling
      } finally {
        setIsLoading(false);
        setIsTableLoading(false);
      }
    };

    fetchHardwares();
  }, []);

  useEffect(() => {
    if ((!isLoading && !originalFormValues) || (data.vehicle.startsWith("AST") && !originalFormValues)) {
      setOriginalFormValues({
        hardware: hardwareSelected,
        contact: contact || "",
        phone: phone || "",
        email: email || "",
        reason: reasonSelected,
        dontShipCheckBox: isDontShipFromHardware,
        address: [
          bundleData.address,
          bundleData.address1 ? bundleData.address1 : null,
          bundleData.city,
          bundleData.stateCode,
          bundleData.zipCode,
          bundleData.countryCode,
        ]
          .filter((item) => item !== null && item !== "")
          .join(", "),
      });
    }
    if (
      !isLoading &&
      !originalFormValues?.selectedHardwareSpecifier &&
      selectedHardwareSpecifier &&
      Object.keys(selectedHardwareSpecifier).length > 0
    ) {
      const selectedSpecifierMaterialMap = selectedHardwareSpecifier
        ? Object.entries(selectedHardwareSpecifier).reduce((acc, [key, spec]) => {
            const val = spec?.isActionable ? spec?.selectedMaterialId || spec?.materials?.[0]?.materialId : spec?.materials?.[0]?.materialId;
            acc[key] = val ?? null;
            return acc;
          }, {})
        : {};
      setOriginalFormValues((prev) => ({
        ...prev,
        selectedHardwareSpecifier: selectedSpecifierMaterialMap,
      }));
    }
  }, [isLoading, hardwareSelected, reasonSelected, selectedHardwareSpecifier, address, isDontShipFromHardware]);

  useEffect(() => {
    if (!originalFormValues) return;
    const hardwareChanged = hardwareSelected !== originalFormValues.hardware;
    const contactChanged = contact !== originalFormValues.contact;
    const phoneChanged = phone !== originalFormValues.phone;
    const emailChanged = email !== originalFormValues.email;
    const reasonChanged = reasonSelected !== originalFormValues.reason;
    const addressChanged = (() => {
      if (!originalFormValues.address) return false;
      if (isFieldsChanged) {
        const currentAddress = [
          address.address1.value,
          address.address2.value,
          address.city.value,
          address.state.value?.erpStateCode,
          address.zip.value,
          address.country.value?.code,
        ]
          .filter((item) => item !== null && item !== "")
          .join(", ");
        return currentAddress !== originalFormValues.address;
      } else return false;
    })();

    const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
    const isPriority1 = selectedHardwareInfo && selectedHardwareInfo.priority === 1;

    const isDropdownExists =
      materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected)?.recommendations?.filter((e) => e.isActionable).length ||
      false;

    // when there is a dropdown and changes in dropdown values selection - add case for hardware specifier
    const formattedSelectedHardwareSpecifier = selectedHardwareSpecifier
      ? Object.entries(selectedHardwareSpecifier).reduce((acc, [key, spec]) => {
          const val = spec?.isActionable ? spec?.selectedMaterialId || spec?.materials?.[0]?.materialId : spec?.materials?.[0]?.materialId;
          acc[key] = val ?? null;
          return acc;
        }, {})
      : {};
    const isMaterialDropdownChanged =
      isDropdownExists && !isEqual(formattedSelectedHardwareSpecifier, originalFormValues.selectedHardwareSpecifier || {});

    const isDontShipFromHardwareChanged = !isEqual(isDontShipFromHardware, originalFormValues.dontShipCheckBox);

    const anyFieldChanged =
      hardwareChanged ||
      contactChanged ||
      phoneChanged ||
      emailChanged ||
      isDontShipFromHardwareChanged ||
      (!isPriority1 && reasonChanged) ||
      isMaterialDropdownChanged ||
      addressChanged;
    setIsCriticalFieldsChanged(anyFieldChanged);
  }, [
    hardwareSelected,
    contact,
    phone,
    email,
    reasonSelected,
    hardwares,
    selectedHardwareSpecifier,
    vehicleDetails.vehicleStatus,
    address,
    existingHardwareRequest,
    hardwareRequestInitiated,
    isDontShipFromHardware,
    isFieldsChanged,
  ]);

  // when the vehcile in needs attention state and there is no existing hardware request and recommendation present then we enable save button
  const isMaterialChanged = useMemo(() => {
    const isDropdownExists =
      materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected)?.recommendations?.filter((e) => e.isActionable).length ||
      false;

    const isMaterialsChanged =
      !existingHardwareRequest &&
      !hardwareRequestInitiated &&
      (vehicleDetails.deviceType === "ASSET" ? materialsAndPriorities?.length : hardwares.length) &&
      !isDropdownExists &&
      vehicleDetails.vehicleStatus === "Warning";
    return isMaterialsChanged;
  }, [
    existingHardwareRequest,
    hardwareRequestInitiated,
    hardwareSelected,
    hardwares.length,
    materialsAndPriorities,
    vehicleDetails.deviceType,
    vehicleDetails.vehicleStatus,
  ]);

  useEffect(() => {
    if (existingHardwareRequest) return;

    const currentHardwareMap = vehicleDetails.materialMapping.reduce((acc, cur) => {
      const { id } = cur;
      if (!isClosedLineItem(cur)) {
        const { isActionable, materials, selectedMaterialId } = selectedHardwareSpecifier?.[id] || {};
        acc[id] = materials ? (isActionable ? selectedMaterialId : materials[0].materialId) : null;
        return acc;
      }
      return acc;
    }, {});
    const isRequestedHardwareChanged = !isEqual(currentHardwareMap, requestedHardwareFromDropdown) || !!addedMaterials.length;
    setIsRequestedHardwareChanged(isRequestedHardwareChanged);
  }, [requestedHardwareFromDropdown, addedMaterials, vehicleDetails.materialMapping, selectedHardwareSpecifier, existingHardwareRequest]);

  const subscriptionIdToInstallTypeMap = useMemo(() => {
    const subscriptionsList =
      cspInfo?.data?.data?.Product?.filter((p) => p.BundleId === bundleId && p.AssetType.toLowerCase() === assetType.toLowerCase()) || [];

    const map = subscriptionsList.reduce((acc, product) => {
      acc[String(product.SAPProductID)] = product.InstallationType;
      return acc;
    }, {});
    return map;
  }, [cspInfo, bundleId, assetType]);

  const refetchVehicleData = async () => {
    // Refetch the data to ensure the UI is in sync
    setIsTableLoading(true);
    const updatedVehicleDetails = await ViewVehicleList(
      bundleId,
      undefined,
      undefined,
      cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
      undefined,
      vehicleDetails.id
    );
    if (updatedVehicleDetails.status === 200 && updatedVehicleDetails.data?.data) {
      const vehicleData = updatedVehicleDetails.data?.data?.vehicles[`${bundleId}`];
      if (vehicleData.length) {
        const updatedVeh = {
          ...vehicleData[0],
          materialMapping: vehicleData[0].materialMapping.map((item) => ({
            ...item,
            materials: [{ materialId: item.hardwareId, materialName: item.hardwareName }],
          })),
        };
        setVehicleDetails(updatedVeh);
        setIsStartRequestDisabled(vehicleData[0].materialMapping.every((item) => item.status?.toLowerCase() === "submitted"));
        setIsDoNotShipChanged(false);

        // **KEY FIX**: Update the form's baseline state after a successful save.
        setOriginalFormValues({
          hardware: hardwareSelected,
          contact: contact || "",
          phone: phone || "",
          email: email || "",
          reason: reasonSelected,
          dontShipCheckBox: vehicleData[0]?.materialMapping ? buildDontShipCheckboxState(vehicleData[0]?.materialMapping) : {},
          selectedHardwareSpecifier: selectedHardwareSpecifier,
          address: [
            address.address1.value,
            address.address2.value,
            address.city.value,
            address.state.value?.erpStateCode,
            address.zip.value,
            address.country.value?.code,
          ]
            .filter((item) => item !== null && item !== "")
            .join(", "),
        });
        origData.current = {
          ...vehicleData[0],
          materialMapping: vehicleData[0].materialMapping.map((item) => ({
            ...item,
            materials: [{ materialId: item.hardwareId, materialName: item.hardwareName }],
          })),
        };
        setIsCriticalFieldsChanged(false); // Disable save button until next edit
        assignHardwareToHardwareSpecifierMapCreation(vehicleData[0].materialMapping);
        setIsTableLoading(false);
        return updatedVeh;
      }
    } else {
      notify("Failed to refresh vehicle data.", "error");
    }
    setIsTableLoading(false);
    return null;
  };

  const getSelectedMaterialPayload = (item) => {
    const spec = selectedHardwareSpecifier?.[item.id];
    const { subscriptionId } = item;
    if (spec) {
      const { isActionable, selectedMaterialId, selectedMaterial, materials } = spec;
      if (!isActionable) {
        const fallback = materials?.[0];
        return {
          materialId: fallback?.materialId || item.hardwareId || null,
          materialName: fallback?.materialName || item.hardwareName || null,
          isActionableChanged: false,
          isClosedLineItem: false,
        };
      } else {
        return {
          materialId: selectedMaterialId || null,
          materialName: selectedMaterial?.materialName || null,
          isActionableChanged: true,
          isClosedLineItem: false,
        };
      }
    } else {
      return {
        materialId: null,
        materialName: null,
        isActionableChanged: false,
        isClosedLineItem: false,
        // if there is no recommendation for the given subscriptionId then we should not delete the line item else we need to delete
        isDelete: noRecommendationSubscription.includes(subscriptionId) ? false : true,
      };
    }
  };

  const handleClick = async () => {
    // --- 1. VALIDATION ---
    if (!data.vehicle.startsWith("AST") && hardwares.length) {
      if (!hardwareSelected || hardwareSelected === "") {
        notify("Please select hardware", "error");
        return;
      }

      const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
      const priority = selectedHardwareInfo ? selectedHardwareInfo.priority : defaultPriority;

      if (priority !== 1 && (!reasonSelected || reasonSelected === "Select Reason")) {
        notify("Please select a reason", "error");
        return;
      }
    }
    if (!contact || contact.trim() === "") {
      notify("Please enter a contact name", "error");
      return;
    }
    if (!phone || phone.trim() === "") {
      notify("Please enter a phone number", "error");
      return;
    }
    if (!email || email.trim() === "") {
      notify("Please enter an email address", "error");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      notify("Please enter a valid email address", "error");
      return;
    }
    const phoneRegex = /^(\(\d{3}\)\s?\d{3}-\d{4}|\d{10}|\+1\d{10})$/;
    if (!phoneRegex.test(phone)) {
      notify("Please enter a valid phone number", "error");
      return;
    }

    if (address.address1.error || address.city.error || address.state.error || address.country.error || address.zip.error) {
      notify("Please enter a valid address", "error");
      return;
    }

    // --- 2. API CALL AND STATE MANAGEMENT ---
    setIsLoading(true);
    setIsSaving(true); // Set saving state to true at the beginning

    try {
      const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
      const priority = selectedHardwareInfo ? selectedHardwareInfo.priority : defaultPriority;

      const bundleOrderType = cspInfo?.data?.data?.Product?.find((p) => p.BundleId === bundleId)?.OrderDetailType;
      const payload = {
        id: data.id ? parseInt(data.id, 10) : null,
        vin: data.vehicle,
        isAddressUpdated: isFieldsChanged,
        addressId: bundleData.addressId,
        address1: address.address1.value,
        address2: address.address2.value,
        city: address.city.value,
        country: address.country.value?.code,
        countryCode: address.country.value?.code,
        stateCode: address.state.value?.erpStateCode,
        zipCode: address.zip.value,
        timezone: address.timezone,
        addressByPass: address.addressByPass,
        locationFound: address.locationFound,
        locusLocationId: address.locusLocationId,
        dpv: address.dpv,
        dpvDetails: address.dpvDetail,
        latitude: address.latitude,
        longitude: address.longitude,
        locusSuggestedAddress: address.locusSuggestedAddress,
        contactId: bundleData.contactId,
        customerName: contact,
        customerEmail: email,
        customerPhone: phone,
        modifiedBy: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
        salesOrgId: cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
        crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
        bundleId: bundleId,
        isShippingBlocked: doNotShipCheckboxSelected,
        bundleOrderType: vehicleDetails.materialMapping.length ? vehicleDetails.materialMapping[0].orderType : bundleOrderType,
        ...(data.vehicle.startsWith("AST")
          ? {}
          : {
              reasonForChanging: priority === 1 ? null : reasonSelected ? parseInt(reasonSelected, 10) : null,
              hardwareSelected: hardwareSelected,
              hardwarePriority: priority,
              isHardwareChange: existingHardwareRequest
                ? false
                : vehicleDetails.priority === null && hardwareSelected
                ? true
                : hardwareSelected !== originalFormValues.hardware,
              //if any status is present always we r sending as false from UI - this is for the bug vehicle is removed from assigned hardware automatically
            }),
        vehicleSubscriptions: existingHardwareRequest
          ? vehicleDetails.materialMapping.map((item) => ({
              id: item.id,
              subscriptionName: item.subscriptionName,
              subscriptionId: item.subscriptionId || null,
              techRefId: item.techRefId || null,
              materialId: item.hardwareId || null,
              materialName: item.hardwareName || null,
              comment: commentText,
              quantity: item.quantity,
              isClosedLineItem: isClosedLineItem(item),
              isActionableChanged: false,
              isShipmentHold: isDontShipFromHardware[item.id],
              installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
            }))
          : hardwareSelected === originalFormValues.hardware && !!origData.current.materialMapping.length && vehicleDetails.priority !== null
          ? vehicleDetails.materialMapping.map((item) => ({
              // need to get deleted the extra materials do not having the hws
              id: item.id,
              subscriptionName: item.subscriptionName,
              subscriptionId: item.subscriptionId || null,
              installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
              techRefId: item.techRefId || null,
              ...(!isClosedLineItem(item)
                ? getSelectedMaterialPayload(item)
                : {
                    materialId: item.hardwareId || null,
                    materialName: item.hardwareName || null,
                    isActionableChanged: false,
                    isClosedLineItem: true,
                  }),
              comment: commentText,
              quantity: item.quantity,
              isShipmentHold: isDontShipFromHardware[item.id],
            }))
          : [
              ...origData.current.materialMapping.map((item) => ({
                id: item.id,
                subscriptionName: item.subscriptionName,
                subscriptionId: item.subscriptionId || null,
                installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
                techRefId: item.techRefId || null,
                materialId: item.hardwareId || null,
                materialName: item.hardwareName || null,
                comment: commentText,
                quantity: item.quantity,
                isClosedLineItem: isClosedLineItem(item),
                isShipmentHold: isDontShipFromHardware[item.id],
              })),
              ...vehicleDetails.materialMapping
                .filter((item) => isClosedLineItem(item) !== true)
                .map((item) => ({
                  // need to get deleted the extra materials do not having the hws
                  subscriptionName: item.subscriptionName,
                  subscriptionId: item.subscriptionId || null,
                  installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
                  techRefId: item.techRefId || null,
                  ...getSelectedMaterialPayload(item),
                  comment: commentText,
                  quantity: item.quantity,
                  isShipmentHold: isDontShipFromHardware[item.id],
                  originalVinMaterial: item.originalVinMaterial,
                  lineType: item.lineType,
                }))
                .filter((item) => item?.isDelete !== true), // filter out items marked for deletion
            ],
      };

      const response = await updateHardware(payload, parseInt(data.id, 10));

      if (response?.status === 200) {
        notify("Vehicle updated successfully!", "success");
        await refetchVehicleData();
      } else {
        notify(response?.data?.message || "Vehicle Update Failed", "error");
      }
    } catch (error) {
      notify(error?.response?.data?.message || "An unexpected error occurred.", "error");
    } finally {
      setIsLoading(false);
      setIsTableLoading(false);
      // **KEY FIX**: Set isSaving back to false to allow future interactions.
      setIsSaving(false);
    }
  };

  const handleChangeVehicle = async () => {
    try {
      setIsLoading(true);
      setIsTableLoading(true);
      const refreshedVehicle = await refetchVehicleData();
      // fetch new recommendations based on new vehicle info
      const materialResponse = await getMaterialMappings(
        refreshedVehicle ? prepareHardwareApiPayload(refreshedVehicle) : prepareHardwareApiPayload()
      );
      const { partRecommendationResponse, hardwareList, selectedHardware = null } = processMaterialResponse(materialResponse);
      setMaterialsAndPriorities(partRecommendationResponse);
      setHardwares(hardwareList);
      setHardwareSelected(selectedHardware);
      assignHardwareToHardwareSpecifierMapCreation(vehicleDetails?.materialMapping);
    } catch (error) {
      notify("Failed to change vehicle and fetch recommendations.", "error");
    } finally {
      setIsLoading(false);
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (notificationTimeoutRef.current) {
        clearTimeout(notificationTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (notification && notificationInteractionRef.current) {
        setNotification(null);
        if (notificationTimeoutRef.current) {
          clearTimeout(notificationTimeoutRef.current);
          notificationTimeoutRef.current = null;
        }
      }

      const interactionTimer = setTimeout(() => {
        notificationInteractionRef.current = true;
      }, 1000);

      document.addEventListener("click", handleUserInteraction);
      document.addEventListener("input", handleUserInteraction);
      document.addEventListener("change", handleUserInteraction);

      return () => {
        document.removeEventListener("click", handleUserInteraction);
        document.removeEventListener("input", handleUserInteraction);
        document.removeEventListener("change", handleUserInteraction);
        clearTimeout(interactionTimer);
      };
    };
  }, [notification]);

  useEffect(() => {
    // Only call when both materialsAndPriorities and hardwareSelected are available
    if (materialsAndPriorities && (assetType !== "Asset" ? hardwareSelected : true) && vehicleDetails?.materialMapping?.length > 0) {
      assignHardwareToHardwareSpecifierMapCreation(vehicleDetails?.materialMapping);
    }
  }, [materialsAndPriorities, hardwareSelected, vehicleDetails?.materialMapping, assignHardwareToHardwareSpecifierMapCreation, assetType]);

  const handleDontShipChange = (id) => {
    setIsDontShipFromHardware((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length > 10) return digits;
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handlePhoneChange = (value) => {
    const isIntlFormat = value.startsWith("+");
    if (isIntlFormat) {
      const rawDigits = value.replace(/[^0-9]/g, "");
      if (rawDigits.length === 0) {
        setPhone("+");
        setPhoneError(true);
        setPhoneErrorText("Enter +1 followed by 10 digits");
      } else {
        const forced = "1" + rawDigits.replace(/^1/, "");
        const cleaned = "+" + forced;
        const phoneDigits = forced.slice(1);
        setPhone(cleaned);
        if (phoneDigits.length === 10) {
          setPhoneError(false);
          setPhoneErrorText("");
        } else if (phoneDigits.length > 10) {
          setPhoneError(true);
          setPhoneErrorText("Only 10 digits allowed");
        } else {
          setPhoneError(true);
          setPhoneErrorText("Enter +1 followed by 10 digits");
        }
      }
    } else {
      const digits = value.replace(/\D/g, "");
      const formatted = formatPhoneNumber(value);
      setPhone(formatted);
      if (digits.length === 10) {
        setPhoneError(false);
        setPhoneErrorText("");
      } else if (digits.length > 10) {
        setPhoneError(true);
        setPhoneErrorText("Only 10 digits allowed");
      } else if (digits.length > 0) {
        setPhoneError(true);
        setPhoneErrorText("Enter 10 digit phone number");
      } else {
        setPhoneError(true);
        setPhoneErrorText("Enter phone number");
      }
    }
  };

  const notify = (content, type) => {
    if (notificationTimeoutRef.current) {
      clearTimeout(notificationTimeoutRef.current);
      notificationTimeoutRef.current = null;
    }

    notificationInteractionRef.current = false;

    if (!content) {
      setNotification(null);
      return;
    }

    setNotification(
      <>
        <Notification
          key={generate()}
          type={type}
          title={content}
          fullBleed={true}
          onCloseButtonClick={() => {
            if (notificationTimeoutRef.current) {
              clearTimeout(notificationTimeoutRef.current);
              notificationTimeoutRef.current = null;
            }
            setNotification(null);
          }}
        />
        <br />
      </>
    );

    if (type !== "error") {
      notificationTimeoutRef.current = setTimeout(() => {
        setNotification(null);
        notificationTimeoutRef.current = null;
      }, 5000);
    }
  };

  const createHardwareRequestHandler = async () => {
    const ids = Object.keys(
      Object.entries(requestedHardwareFromDropdown).reduce((acc, [key, value]) => {
        if (value !== "selectHardware") {
          acc[key] = value;
        }
        return acc;
      }, {})
    );
    const requestedMapping = vehicleDetails.materialMapping
      .filter((item) => ids.includes(item.id))
      .map((item) => ({
        subscriptionName: item.subscriptionName,
        subscriptionId: item.subscriptionId,
        techRefId: item.techRefId,
        materialId: requestedHardwareFromDropdown[item.id] || null,
        materialName: (requestedMaterialList[Number(item.subscriptionId)] || []).find((m) => m.materialId === requestedHardwareFromDropdown[item.id])
          ?.materialName,
        deviceType: hardwareSelected,
        lineType: item.lineType || null,
        ...(item.lineType === "Reship" ? { originalVinMaterial: item.originalVinMaterial } : {}),
        installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
      }));
    if (addedMaterials.length) {
      requestedMapping.push(
        ...addedMaterials.map(({ subscriptionId, subscriptionName, techRefId, materialId, materialName, lineType }) => ({
          subscriptionId,
          subscriptionName,
          techRefId,
          materialId,
          materialName,
          deviceType: hardwareSelected,
          lineType,
          installType: subscriptionIdToInstallTypeMap[String(subscriptionId)] || null,
        }))
      );
    }

    const bundleOrderType = cspInfo?.data?.data?.Product?.find((p) => p.BundleId === bundleId)?.OrderDetailType;

    const payload = {
      bundle: bundleId,
      action: "CREATE",
      order: cspInfo?.data?.data?.CSP?.[0]?.Provider_Order,
      crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
      cspId: cspInfo?.data?.data?.CSP?.[0]?.CSPID,
      accountName: cspInfo?.data?.data?.AccountName,
      vehicleId: data.id ? parseInt(data.id, 10) : null,
      deploymentAgent: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
      salesOrgId: cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
      bundleOrderType: vehicleDetails.materialMapping.length ? vehicleDetails.materialMapping[0].orderType || bundleOrderType : bundleOrderType,
      requestedHardwareMapping: requestedMapping,
      reasonForChange: reasonForChangingRecommendation || "NA",
      deploymentAgentComments: hardwareChangeComment,
    };
    const response = await createHardwareRequest(payload);
    if (response?.status === 200) {
      setIsTableLoading(true);
      setExistingHardwareRequest(response.data.data[0]);
      setVehicleDetails((prev) => ({ ...prev, vehicleStatus: "Warning" }));
      setIsTableLoading(false);
    }
  };

  const updateHardwareRequestHandler = async (action) => {
    if (!existingHardwareRequest && action === "USER_CANCEL") {
      setExistingHardwareRequest(null);
      setAddedMaterials([]);
      setRequestedHardwareFromDropdown({});
      setHardwareRequestInitiated(false);
      await refetchVehicleData();
      return;
    }

    const materialMapping = [];
    if (
      vehicleDetails?.materialMapping &&
      vehicleDetails.materialMapping?.length > 0 &&
      selectedHardwareSpecifier &&
      action === "USER_USE_HARDWARE_SPECIFIER"
    ) {
      vehicleDetails.materialMapping.forEach((item) => {
        Object.entries(selectedHardwareSpecifier).forEach(([key, value]) => {
          if (key === item.id) {
            materialMapping.push({
              subscriptionName: item?.subscriptionName,
              techRefId: item?.techRefId,
              subscriptionId: item?.subscriptionId,
              crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
              materialId: value?.selectedMaterial ? value?.selectedMaterial?.materialId : value?.materials[0]?.materialId, // write ternary check if selectedMaterial exists
              materialName: value?.selectedMaterial ? value?.selectedMaterial?.materialName : value?.materials[0]?.materialName, // write ternary check if selectedMaterial exists
              deviceType: value?.deviceType ? value?.deviceType : "",
              lineType: item.lineType || null,
              isClosedLineItem: isClosedLineItem(item),
              ...(item.lineType === "Reship" ? { originalVinMaterial: item.originalVinMaterial } : {}),
              installType: subscriptionIdToInstallTypeMap[String(item.subscriptionId)] || null,
              priority: vehicleDetails.priority,
            });
          }
        });
      });
    }

    const bundleOrderType = cspInfo?.data?.data?.Product?.find((p) => p.BundleId === bundleId)?.OrderDetailType;
    const payload =
      action === "USER_USE_HARDWARE_SPECIFIER"
        ? {
            action: "USER_USE_HARDWARE_SPECIFIER",
            deploymentAgent: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
            bundle: bundleId || "",
            order: cspInfo?.data?.data?.CSP?.[0]?.Provider_Order || "",
            accountName: cspInfo?.data?.data?.AccountName || "",
            reasonForChange: reasonForChangingRecommendation || "",
            hardwareSpecifierMapping: materialMapping || [],
            salesOrgId: cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
            bundleOrderType: bundleOrderType,
            deploymentAgentComments: hardwareChangeComment,
            crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
            priority: vehicleDetails.priority,
          }
        : {
            action,
            deploymentAgent: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
            crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
          };

    const response = await updateHardwareRequest(payload, existingHardwareRequest.id);
    if (response?.status === 200) {
      if (action === "USER_CLEARED") {
        setExistingHardwareRequest(null);
        setShowClearRequestModal(false);
        setReasonForChangingRecommendation("");
        setHardwareChangeComment("");
      } else {
        setExistingHardwareRequest(action === "USER_CANCEL" ? null : response.data.data[0]);
        setAddedMaterials([]);
        setRequestedHardwareFromDropdown({});
      }
      setHardwareRequestInitiated(false);
      await refetchVehicleData();
    } else {
      notify("An unexpected error occurred.", "error");
    }
  };

  const subscriptionTableBody = useMemo(() => {
    if (vehicleDetails.materialMapping.length === 0) return [];
    const final = [];
    const groupBySubscriptionId = groupBy(vehicleDetails.materialMapping, "subscriptionId");
    Object.keys(groupBySubscriptionId).forEach((key) => {
      const filterNullTypes = groupBySubscriptionId[key].filter((item) => !!item.type);
      let type = filterNullTypes.length > 0 ? filterNullTypes[0].type : "--";
      if (type !== "--") {
        if (type?.toLowerCase() === "core") {
          type = "Core";
        } else if (type?.toLowerCase() === "companion") {
          type = "Companion";
        } else if (type?.toLowerCase() === "feature") {
          type = "Feature";
        }
      }
      final.push({
        type,
        subscriptionName: groupBySubscriptionId[key][0].subscriptionName || "—",
        subscriptionId: groupBySubscriptionId[key][0].subscriptionId,
        techRefId: groupBySubscriptionId[key][0].techRefId,
        hardware: groupBySubscriptionId[key],
      });
    });

    const desiredOrder = ["Core", "Companion", "Feature"];

    final.sort((a, b) => {
      const aIndex = desiredOrder.indexOf(a.type);
      const bIndex = desiredOrder.indexOf(b.type);
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
    });
    return final;
  }, [vehicleDetails.materialMapping]);

  const renderDontShipCheckBox = (rowData) => {
    if (!rowData.hardware || rowData.hardware.length === 0) {
      return null;
    }
    const { hardware } = rowData;
    return hardware.map((item, itemIndex) => {
      return (
        <>
          {item?.lineType && !isClosedLineItem(item) ? (
            <StyledDontShipCheckbox
              key={itemIndex}
              selected={isDontShipFromHardware[item.id]}
              role="checkbox"
              aria-checked={isDontShipFromHardware[item.id]}
              type="checkbox"
              name="default"
              width="auto"
              onChange={() => {
                handleDontShipChange(item.id);
              }}
            />
          ) : (
            <StyledDontShipCheckboxHidden key={itemIndex} selected={false} type="checkbox" name="default" disabled={true} />
          )}
        </>
      );
    });
  };
  const renderHardwareDetails = (rowData) => {
    if (!rowData.hardware || rowData.hardware.length === 0) {
      return "--";
    }
    const { hardware } = rowData;

    return hardware.map((item, itemIndex) => {
      const { hardwareId, hardwareName } = item;
      return (
        <div
          key={itemIndex}
          style={{
            color: !isClosedLineItem(item) ? "#000" : "#6F7171",
            fontSize: "12px",
            marginTop: "12px",
            marginBottom: "12px",
            fontFamily: "Verizon-NHG-eTX",
            height: "44px",
          }}
        >
          {hardwareId ? ( //isCleared indicates material reset on Clear Request
            <>
              <div>{hardwareName}</div>
              <div>{hardwareId ? `${hardwareId}` : ""}</div>
            </>
          ) : (
            <div>--</div>
          )}
        </div>
      );
    });
  };

  const renderRequestedHardware = (rowData) => {
    const { hardware, subscriptionId } = rowData;
    if (hardwareRequestInitiated && rowData.hardware.length && !existingHardwareRequest) {
      // when there is no existing requested data
      const addedMaterialsData = addedMaterials.filter((e) => e.subscriptionId === subscriptionId);

      const rows = hardware.map((item, itemIndex) => {
        const { subscriptionId } = item;
        const materials = requestedMaterialList[Number(subscriptionId)] || [];
        const isClosed = isClosedLineItem(item);
        if (!isClosed) {
          const options = [
            { value: "selectHardware", label: "Select Hardware" },
            ...materials.map((m) => {
              return { value: m.materialId, label: `${m.materialName} (${m.materialId})` };
            }),
          ];

          return (
            <div key={item.id} style={{ width: "250px", marginBottom: "10px", ...(itemIndex !== 0 ? { marginTop: "10px" } : {}) }}>
              <CustomisedDropdown
                key={item.id}
                options={options}
                onChange={(e) => {
                  setRequestedHardwareFromDropdown((prev) => {
                    return {
                      ...prev,
                      [item.id]: e.value,
                    };
                  });
                }}
                filter
                filterBy="label,value"
                value={requestedHardwareFromDropdown[item.id] || "selectHardware"}
                className="my-custom-dropdown"
                style={{
                  width: "100%",
                  color: isClosed ? "#6F7171" : "#000",
                  fontSize: "16px",
                  fontFamily: "Verizon-NHG-eDS",
                  borderRadius: "0px",
                  borderWidth: "0.0625rem",
                  borderStyle: "solid",
                  borderColor: "rgb(216, 218, 218) rgb(216, 218, 218) rgb(0, 0, 0)",
                }}
              />
            </div>
          );
        } else {
          return (
            <div
              key={item.id}
              style={{
                width: "250px",
                marginBottom: "10px",
                padding: "12px",
                fontFamily: "Verizon-NHG-eDS",
                minHeight: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6F7171",
                ...(itemIndex !== 0 ? { marginTop: "10px" } : {}),
              }}
            >
              --
            </div>
          );
        }
      });

      rows.push(
        ...addedMaterialsData.map((addedItem) => {
          return (
            <div key={addedItem.id} style={{ width: "250px", marginBottom: "10px", marginTop: "10px" }}>
              <div style={{ padding: "12px", fontFamily: "Verizon-NHG-eDS", minHeight: "44px", backgroundColor: "#fff" }}>
                {addedItem.materialName} ({addedItem.materialId})
              </div>
            </div>
          );
        })
      );
      return rows;
    } else if (existingHardwareRequest) {
      const { hardware, subscriptionId } = rowData;
      const requestedMaterials = existingHardwareRequest.requestedHardwareMapping.filter((e) => e.subscriptionId === subscriptionId);

      const renderItems = [];
      let requestedMaterialIndex = 0;
      hardware.forEach((hardwareItem, index) => {
        const { id, subType } = hardwareItem;
        const isClosed = isClosedLineItem(hardwareItem);
        const correspondingRequestedItem =
          index === 0 && subType === "Main" && requestedMaterials[requestedMaterialIndex]?.subType !== "Main"
            ? null
            : requestedMaterials[requestedMaterialIndex];
        if (correspondingRequestedItem) {
          renderItems.push(
            <div key={`enabled-${id || index}`} style={{ width: "250px", marginBottom: "10px", ...(index !== 0 ? { marginTop: "10px" } : {}) }}>
              <div
                style={{
                  padding: "12px",
                  fontFamily: "Verizon-NHG-eDS",
                  minHeight: "44px",
                  backgroundColor: "#fff",
                  border: "1px solid #D8DADA",
                  color: "#000",
                }}
              >
                {correspondingRequestedItem.materialName} ({correspondingRequestedItem.materialId})
              </div>
            </div>
          );
          requestedMaterialIndex++;
        } else {
          renderItems.push(
            <div key={`disabled-${id || index}`} style={{ width: "250px", marginBottom: "10px", ...(index !== 0 ? { marginTop: "10px" } : {}) }}>
              <div
                style={{
                  padding: "12px",
                  fontFamily: "Verizon-NHG-eDS",
                  minHeight: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: isClosed ? "#6F7171" : "#000",
                }}
              >
                --
              </div>
            </div>
          );
        }
      });

      // If there are remaining requested materials after processing all hardware items
      const remainingRequestedMaterials = requestedMaterials.slice(requestedMaterialIndex);

      remainingRequestedMaterials.forEach((additionalItem, index) => {
        const actualIndex = requestedMaterialIndex + index;

        renderItems.push(
          <div key={`additional-${actualIndex}`} style={{ width: "250px", marginBottom: "10px", ...(index !== 0 ? { marginTop: "10px" } : {}) }}>
            <div
              style={{
                padding: "12px",
                fontFamily: "Verizon-NHG-eDS",
                minHeight: "44px",
                backgroundColor: "#fff",
                border: "1px solid #D8DADA",
                color: "#000",
              }}
            >
              {additionalItem.materialName} ({additionalItem.materialId})
            </div>
          </div>
        );
      });

      return renderItems;
    }

    return "";
  };
  const renderApprovedChanges = (rowData) => {
    if (existingHardwareRequest && existingHardwareRequest?.approvedHardwareMapping?.length) {
      const { subscriptionId, hardware } = rowData;
      const approvedHardware = existingHardwareRequest.approvedHardwareMapping.filter((e) => e.subscriptionId === subscriptionId);
      const approvedHardwareDiv = [];
      let approvedMaterialIndex = 0;
      hardware.map((item, index) => {
        const { subType } = item;
        const isClosed = isClosedLineItem(item);
        const correspondingApprovedItem =
          index === 0 && subType === "Main" && approvedHardware[approvedMaterialIndex]?.subType !== "Main"
            ? null
            : approvedHardware[approvedMaterialIndex];
        if (!correspondingApprovedItem || approvedHardware.length === 0) {
          approvedHardwareDiv.push(
            <div
              key={index}
              style={{
                marginTop: "12px",
                marginBottom: "12px",
                fontFamily: "Verizon-NHG-eDS",
                height: "44px",
                color: isClosed ? "#6F7171" : "#000",
              }}
            >
              --
            </div>
          );
        } else {
          approvedMaterialIndex++;
          approvedHardwareDiv.push(
            <div
              key={index}
              style={{
                marginTop: "12px",
                marginBottom: "12px",
                fontFamily: "Verizon-NHG-eDS",
                height: "44px",
                color: isClosed ? "#6F7171" : "#000",
                fontSize: "12px",
              }}
            >
              <div>{correspondingApprovedItem.materialName}</div>
              <div>{correspondingApprovedItem.materialId ? `${correspondingApprovedItem.materialId}` : ""}</div>
            </div>
          );
        }
      });
      // If there are remaining requested materials after processing all hardware items
      const remainingApprovedMaterials = approvedHardware.slice(approvedMaterialIndex);
      if (remainingApprovedMaterials) {
        remainingApprovedMaterials.map((item, index) => {
          approvedHardwareDiv.push(
            <div
              key={index}
              style={{
                marginTop: "12px",
                marginBottom: "12px",
                fontFamily: "Verizon-NHG-eDS",
                height: "44px",
                color: "#000",
                fontSize: "12px",
              }}
            >
              <div>{item.materialName}</div>
              <div>{item.materialId ? `${item.materialId}` : ""}</div>
            </div>
          );
        });
      }
      return approvedHardwareDiv;
    } else if (hardwareRequestInitiated) {
      return rowData.hardware.map((item, itemIndex) => {
        const isClosed = isClosedLineItem(item);
        return (
          <div
            key={itemIndex}
            style={{
              marginTop: "12px",
              marginBottom: "12px",
              fontFamily: "Verizon-NHG-eDS",
              height: "44px",
              color: isClosed ? "#6F7171" : "#000",
            }}
          >
            --
          </div>
        );
      });
    }
  };

  const onStartRequestClick = async () => {
    setHardwareRequestInitiated(true);
    //set requested hardware to hardware specifier here--
    const subscriptionList = [...new Set(vehicleDetails.materialMapping.map((e) => e.subscriptionId))];
    const contractDetailsPromises = subscriptionList.map((subId) => getContractDetails(subId, cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org));
    const contractDetailsResponses = await Promise.all(contractDetailsPromises);
    const requestedMaterialList = contractDetailsResponses.reduce((acc, res) => {
      const filteredMaterials = res?.data?.data
        .filter((item) => String(item.materialId).startsWith("11") && !item.isObsolete)
        .sort((a, b) => String(a.materialId).localeCompare(String(b.materialId)));
      if (res?.status === 200 && filteredMaterials?.length) {
        acc[filteredMaterials[0].sapId] = filteredMaterials.map((e) => ({
          materialId: e.materialId,
          materialName: e.materialName,
          subscriptionId: e.sapId,
          subscriptionName: e.contractName,
          techRefId: vehicleDetails.materialMapping.find((v) => v.subscriptionId === e.sapId)?.techRefId || null,
        }));
      }
      return acc;
    }, {});
    setRequestedMaterialList(requestedMaterialList);
    const requestedHardwareMap = vehicleDetails.materialMapping.reduce((acc, cur) => {
      const { id } = cur;
      if (!isClosedLineItem(cur)) {
        const { isActionable, materials, selectedMaterialId } = selectedHardwareSpecifier?.[id] || {};
        acc[id] = materials ? (isActionable ? selectedMaterialId : materials[0].materialId) : "selectHardware";
      }
      return acc;
    }, {});
    setRequestedHardwareFromDropdown(requestedHardwareMap);
    setVehicleDetails((prev) => ({ ...prev, vehicleStatus: "Warning" }));
  };

  const handleClearRequest = async () => {
    // make api call to clear request
    await updateHardwareRequestHandler("USER_CLEARED");
  };

  const renderRequestButtonAndStatus = () => {
    if (!hardwareRequestInitiated && !existingHardwareRequest && !isStartRequestDisabled) {
      return (
        <Button
          style={{ marginLeft: "0.5rem" }}
          role="button"
          size="small"
          variant="secondary"
          aria-label="StartRequest"
          data-testid="start-request-button"
          disabled={isLoading || isTableLoading || isCriticalFieldsChanged}
          aria-disabled={isLoading || isTableLoading}
          onClick={() => onStartRequestClick()}
        >
          Start Request
        </Button>
      );
    } else if (hardwareRequestInitiated && (!existingHardwareRequest || existingHardwareRequest?.status === CREATED)) {
      return (
        <span style={{ display: "flex" }}>
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            variant="secondary"
            aria-label="Cancel"
            data-testid="cancel-request-button"
            disabled={isLoading || isTableLoading} // disable if the request status is not created and then make api call
            aria-disabled={isLoading || isTableLoading}
            onClick={() => {
              updateHardwareRequestHandler("USER_CANCEL");
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            variant="secondary"
            aria-label="SendRequest"
            data-testid="send-request-button"
            disabled={
              !!existingHardwareRequest ||
              !(isRequestedHardwareChanged && reasonForChangingRecommendation.trim() !== "" && hardwareChangeComment.trim() !== "")
            }
            aria-disabled={
              !!existingHardwareRequest ||
              !(isRequestedHardwareChanged && reasonForChangingRecommendation.trim() !== "" && hardwareChangeComment.trim() !== "")
            }
            onClick={createHardwareRequestHandler}
          >
            Send Request
          </Button>
        </span>
      );
    } else if (
      existingHardwareRequest &&
      [MODIFIED, APPROVED, REVERTED, MODIFIED_PENDING_AGENT, REVERTED_PENDING_AGENT].includes(existingHardwareRequest.status)
    ) {
      return (
        <Button
          style={{ marginLeft: "0.5rem" }}
          role="button"
          size="small"
          variant="secondary"
          aria-label="clearRequest"
          data-testid="clear-request-button"
          disabled={isLoading || isTableLoading || isCriticalFieldsChanged || isStartRequestDisabled}
          aria-disabled={isLoading || isTableLoading}
          onClick={() => setShowClearRequestModal(true)}
        >
          Clear Request
        </Button>
      );
    }
  };

  //existing hardware map for add materils
  const existingHardwareMap = useMemo(() => {
    if (requestedHardwareFromDropdown && Object.keys(requestedHardwareFromDropdown).length > 0) {
      const subscriptionMaterialMap = vehicleDetails.materialMapping.reduce((acc, item) => {
        const { id, subscriptionId } = item;
        if (requestedHardwareFromDropdown[id]) {
          if (!acc[subscriptionId]) {
            acc[subscriptionId] = [requestedHardwareFromDropdown[id]];
          } else {
            acc[subscriptionId].push(requestedHardwareFromDropdown[id]);
          }
        }
        return acc;
      }, {});
      return subscriptionMaterialMap;
    }
    return {};
  }, [requestedHardwareFromDropdown]);

  const renderLineType = (rowData) => {
    if (!rowData.hardware || rowData.hardware.length === 0) {
      return "--";
    }
    const { hardware } = rowData;

    return hardware.map((item, itemIndex) => {
      const { lineType } = item;
      return (
        <div
          key={itemIndex}
          style={{
            color: isClosedLineItem(item) ? "#6F7171" : "#000",
            fontSize: "11px",
            marginTop: "12px",
            marginBottom: "12px",
            fontFamily: "Verizon-NHG-eTX",
            height: "44px",
          }}
        >
          {lineType ? lineType : "--"}
        </div>
      );
    });
  };

  const renderHardwareSpecifier = (rowData) => {
    if (!materialsAndPriorities) return null;

    // Extract recommendations
    const recommendations = materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected)?.recommendations || [];

    // Filter recommendations based on subscription IDs in rowData
    const requiredRecommendations = recommendations.filter((rec) => rec.subscriptionId === rowData.subscriptionId);
    const available = [...requiredRecommendations];

    const matchType = (rec, subType) => String(rec?.materials?.[0]?.type || "").toLowerCase() === String(subType || "").toLowerCase();

    // Extract all materials from requiredRecommendations
    const modifiedRecommendations = [];
    rowData.hardware.forEach((hardwareItem) => {
      const idx = available.findIndex((r) => matchType(r, hardwareItem?.subType));
      if (idx !== -1) {
        const matchingRecommendation = available.splice(idx, 1)[0];
        // ALWAYS push something to maintain array alignment
        modifiedRecommendations.push({
          ...matchingRecommendation,
          identifier: hardwareItem.id || "",
          enabled: isClosedLineItem(hardwareItem) ? false : true,
        });
      } else {
        modifiedRecommendations.push({
          identifier: hardwareItem.id || "",
          enabled: isClosedLineItem(hardwareItem) ? false : true,
          materials: null,
          noRecommendation: true,
        });
      }
    });

    if (modifiedRecommendations?.length === 0 && rowData.hardware && rowData.hardware.length > 0) {
      const { hardware } = rowData;

      return hardware.map((hardwareItem, index) => renderEmptyCell(index));
    }

    return modifiedRecommendations?.map((recommendation, index) => {
      if (!recommendation.materials || recommendation.noRecommendation) {
        return renderEmptyCell(index);
      }
      if (hardwareRequestInitiated || existingHardwareRequest) {
        // if Isactionable - true and selected material is not there then show material[0]
        if (recommendation.isActionable) {
          const matchingEntry =
            selectedHardwareSpecifier &&
            Object.entries(selectedHardwareSpecifier).find(([key, value]) => key === recommendation.identifier && value?.selectedMaterial);

          if (matchingEntry) {
            const [key, value] = matchingEntry;
            return (
              <div
                key={index}
                style={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  fontFamily: "Verizon-NHG-eTX",
                  minHeight: "44px",
                  color: recommendation.enabled ? "#000" : "#6F7171",
                  fontSize: "12px",
                }}
              >
                <div>{value?.selectedMaterial?.materialName}</div>
                <div>{value?.selectedMaterial?.materialId}</div>
              </div>
            );
          } else {
            // Show default material if no selected material found
            return recommendation?.materials?.[0] ? (
              <div
                key={index}
                style={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  fontFamily: "Verizon-NHG-eTX",
                  minHeight: "44px",
                  color: recommendation.enabled ? "#000" : "#6F7171",
                  fontSize: "12px",
                }}
              >
                <div>{recommendation?.materials[0]?.materialName}</div>
                <div>{recommendation?.materials[0]?.materialId}</div>
              </div>
            ) : (
              renderEmptyCell(index)
            );
          }
        } else {
          return recommendation?.materials?.[0] ? (
            <div
              key={index}
              style={{
                paddingTop: "12px",
                paddingBottom: "12px",
                fontFamily: "Verizon-NHG-eTX",
                minHeight: "44px",
                color: recommendation.enabled ? "#000" : "#6F7171",
                fontSize: "12px",
              }}
            >
              <div>{recommendation?.materials[0]?.materialName}</div>
              <div>{recommendation?.materials[0]?.materialId}</div>
            </div>
          ) : (
            renderEmptyCell(index)
          );
        }
      } else {
        // Closed
        if (!recommendation?.enabled) {
          return recommendation?.materials?.[0] ? (
            <div
              key={index}
              style={{
                paddingTop: "12px",
                paddingBottom: "12px",
                fontFamily: "Verizon-NHG-eTX",
                minHeight: "44px",
                color: "#6F7171",
                fontSize: "12px",
              }}
            >
              <div>{recommendation?.materials[0]?.materialName}</div>
              <div>{recommendation?.materials[0]?.materialId}</div>
            </div>
          ) : (
            renderEmptyCell(index)
          );
        } else {
          if (recommendation?.isActionable && recommendation?.materials?.length !== 0) {
            return (
              <div key={index} style={{ marginBottom: "20px" }}>
                <DropdownSelect
                  className="hardware-specifier-dropdown"
                  key={index}
                  style={
                    selectedHardwareSpecifier?.[recommendation.identifier]?.selectedMaterialId || recommendation?.materials?.[0]?.materialId
                      ? {}
                      : { borderBottom: "4px solid #EE0000" }
                  }
                  value={
                    selectedHardwareSpecifier?.[recommendation.identifier]?.selectedMaterialId ||
                    recommendation?.materials?.[0]?.materialId ||
                    "Select Hardware"
                  }
                  onChange={(e) => {
                    setSelectedHardwareSpecifier((prev) => {
                      const selectedMaterialObject = recommendation?.materials?.find((material) => material.materialId === e.target.value);
                      const newState = {
                        ...prev,
                        [recommendation.identifier]: {
                          ...(prev?.[recommendation.identifier] || {}),
                          selectedMaterial: selectedMaterialObject,
                          selectedMaterialId: e.target.value,
                        },
                      };

                      return newState;
                    });
                  }}
                >
                  <option disabled>Select Hardware</option>
                  {recommendation?.materials?.map((item, index) => (
                    <option key={index} value={item?.materialId}>
                      {item?.materialName} ({item?.materialId})
                    </option>
                  ))}
                </DropdownSelect>
              </div>
            );
          } else {
            return recommendation?.materials?.[0] ? (
              <div key={index} style={{ width: "200px", backgroundColor: "#fff", marginBottom: "10px" }}>
                <div style={{ padding: "12px", fontFamily: "Verizon-NHG-eTX", minHeight: "44px", fontSize: "12px" }}>
                  {recommendation?.materials[0]?.materialName} ({recommendation?.materials[0]?.materialId})
                </div>
              </div>
            ) : (
              renderEmptyCell(index)
            );
          }
        }
      }
    });
  };

  const renderEmptyCell = (index = 0) => (
    <div
      key={index}
      style={{
        padding: "12px",
        // color: "#6F7171",
        fontFamily: "Verizon-NHG-eTX",
        minHeight: "44px",
        justifyContent: "left",
        alignItems: "left",
        display: "flex",
        fontSize: "12px",
      }}
    >
      --
    </div>
  );

  return (
    <>
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "400",
              color: "black",
            }}
            onClick={() => {
              handleChangePage({ index: 0 });
              messageBus.trigger("closeAccordions");
            }}
          >
            Assign Hardware
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            Vehicle Details
          </span>
        </BreadcrumbItem>
      </Breadcrumbs>
      <br />
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 100,
            }}
          >
            <Loader active={true} size="large" />
          </div>
        ) : (
          <>
            <Grid colSizes={{ mobile: 5, tablet: 5, desktop: 2.5 }} css={{ overflow: "hidden" }} style={{ margin: 0 }}>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                <Col css={{ flex: 4, display: "flex", flexDirection: "column", paddingLeft: 0 }}>{notification}</Col>
              </Row>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                <Col css={{ flex: 4, display: "flex", flexDirection: "column", paddingLeft: 0 }}>
                  <div style={{ fontWeight: "bold", fontSize: "1.5rem", fontFamily: "Arial, sans-serif", color: "black" }}>
                    {data.vehicle.startsWith("AST")
                      ? "Asset"
                      : vehicleDetails.displayVinId
                      ? `${vehicleDetails.vehicle} - ${vehicleDetails.year} ${vehicleDetails.make} ${vehicleDetails.model}`
                      : `${vehicleDetails.year} ${vehicleDetails.make} ${vehicleDetails.model}`}
                    {/* Show weightClass if present */}
                    {(vehicleDetails.weightClass || vehicleDetails.wheelChair || vehicleDetails.killSwitch || vehicleDetails.emergency) && (
                      <span
                        style={{
                          color: "#1E1E1E",
                          padding: "2px 2px",
                          marginLeft: 8,
                          display: "inline-flex", // changed to inline-flex for horizontal layout
                          alignItems: "center",
                          gap: "6px", // space between icons and weightClass
                          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "11px",
                          lineHeight: "16px",
                          letterSpacing: "0px",
                          textAlign: "left",
                          textTransform: "none",
                          verticalAlign: "middle",
                        }}
                      >
                        {vehicleDetails.weightClass}
                        {/* Traits icons side by side */}
                        {vehicleDetails.wheelChair && (
                          <Icon
                            className="InternationalSymbolOfAccess"
                            aria-label="InternationalSymbolOfAccess"
                            alt="InternationalSymbolOfAccess"
                            name="international-symbol-of-access"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                        {vehicleDetails.emergency && (
                          <Icon
                            className="police-fleet"
                            aria-label="police-fleet"
                            alt="police-fleet"
                            name="police-fleet"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                        {vehicleDetails.killSwitch && (
                          <Icon
                            className="smart-switch"
                            aria-label="smart-switch"
                            alt="smart-switch"
                            name="smart-switch"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                      </span>
                    )}
                    {/* Badge for vehicleStatus */}
                    {vehicleDetails.vehicleStatus &&
                      (vehicleDetails.vehicleStatus.toLowerCase() === "ready" || vehicleDetails.vehicleStatus.toLowerCase() === "warning") && (
                        <span
                          style={{
                            background: vehicleDetails.vehicleStatus.toLowerCase() === "ready" ? "#008330" : "#EE0000",
                            color: "#FFFFFF",
                            borderRadius: "2px",
                            padding: "2px 4px",
                            fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                            fontSize: "12px",
                            fontWeight: 700,
                            marginLeft: 12,
                            display: "inline-flex",
                            verticalAlign: "middle",
                            alignItems: "center",
                            lineHeight: "16px",
                            letterSpacing: "0px",
                          }}
                        >
                          {vehicleDetails.vehicleStatus.toLowerCase() === "ready" ? "Ready" : "Needs Attention"}
                        </span>
                      )}
                  </div>
                </Col>
                <Col css={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                  {vehicleDetails.changeVehicleEligible && vehicleDetails.deviceType === "VEHICLE" ? (
                    <Button
                      role="button"
                      size="small"
                      secondary
                      data-testid="vehicle-change-button"
                      aria-label="vehicleChange"
                      disabled={isLoading || isSaving}
                      aria-disabled={isLoading || isSaving}
                      onClick={() => {
                        setShowChangeVehicleModal(true);
                      }}
                    >
                      Vehicle Change
                    </Button>
                  ) : (
                    <></>
                  )}
                  <Button
                    style={{ marginLeft: "0.5rem" }}
                    role="button"
                    size="small"
                    variant="secondary"
                    data-testid="save-button"
                    aria-label="saveButton"
                    // --- MODIFIED LOGIC START ---
                    disabled={
                      isLoading ||
                      isSaving ||
                      phoneError ||
                      (!isDoNotShipChanged &&
                        (!(isCriticalFieldsChanged || isMaterialChanged) ||
                          (!existingHardwareRequest &&
                            !data.vehicle.startsWith("AST") &&
                            hardwares.length &&
                            (!hardwareSelected ||
                              hardwareSelected === "" ||
                              (hardwareSelected &&
                                hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 &&
                                (!reasonSelected || reasonSelected === "Select Reason")))) ||
                          !contact ||
                          contact.trim() === "" ||
                          !phone ||
                          phone.trim() === "" ||
                          !email ||
                          email.trim() === "" ||
                          address.historicalAddress.value === "Please select an address or choose Add New to add a new address" ||
                          !address.verified))
                    }
                    aria-disabled={
                      isLoading ||
                      isSaving ||
                      phoneError ||
                      (!isDoNotShipChanged &&
                        (!(isCriticalFieldsChanged || isMaterialChanged) ||
                          (!existingHardwareRequest &&
                            !data.vehicle.startsWith("AST") &&
                            hardwares.length &&
                            (!hardwareSelected ||
                              hardwareSelected === "" ||
                              (hardwareSelected &&
                                hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 &&
                                (!reasonSelected || reasonSelected === "Select Reason")))) ||
                          !contact ||
                          contact.trim() === "" ||
                          !phone ||
                          phone.trim() === "" ||
                          !email ||
                          email.trim() === "" ||
                          address.historicalAddress.value === "Please select an address or choose Add New to add a new address" ||
                          !address.verified))
                    }
                    // --- MODIFIED LOGIC END ---
                    onClick={handleClick}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "15px" }}>
                <Col css={{ flex: 1, display: "flex", flexDirection: "column", position: "relative", paddingLeft: 0 }}>
                  <div style={{ position: "sticky", top: 0 }}>
                    <CommonValidateAddress
                      variant="editVehicle"
                      setModalOpened={setModalOpened}
                      setAlertModal={setAlertModal}
                      address={address}
                      setAddress={setAddress}
                      vehicleData={vehicleData}
                      showHistoricalAddressDropdown={true}
                      setLoader={setIsLoading}
                      notify={notify}
                      defaultCountryOnNew="USA"
                      showTitle={false}
                      showTypedAddressOption={false}
                      trackLocusFields={true}
                      shippingAddress={(() => {
                        if (!bundleData.address || String(bundleData.address).trim() === "") return "";
                        return [
                          bundleData.address,
                          bundleData.address1 ? bundleData.address1 : null,
                          bundleData.city,
                          bundleData.stateCode,
                          bundleData.zipCode,
                          bundleData.countryCode,
                        ]
                          .filter((item) => item != null && String(item).trim() !== "")
                          .join(", ");
                      })()}
                      onFieldsChanged={(changed) => setIsFieldsChanged(changed)}
                      styles={{ containerWidth: "36.5rem" }}
                    />
                    <Grid style={{ maxWidth: "100%" }}>
                      <Row style={{ maxWidth: "100%", paddingLeft: "10px", marginTop: "3px" }}>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                          <div style={{ fontSize: "0.75rem", fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", color: "black" }}>
                            Vehicle Comments
                          </div>
                          <div
                            style={{
                              marginTop: "0.5rem",
                              color: "black",
                              border: "1px solid #D8DADA",
                              height: "88px",
                              width: "36.6rem",
                              overflowY: "auto",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "1rem",
                                padding: "12px",
                                fontWeight: 400,
                                fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                              }}
                            >
                              {hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 ? "" : commentText ?? ""}
                            </div>
                          </div>
                        </CompactCol>
                      </Row>
                    </Grid>
                  </div>
                </Col>
                <Col css={{ flex: 1, display: "flex", flexDirection: "column", alignSelf: "flex-start" }}>
                  <div style={{ position: "sticky", top: 0 }}>
                    <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column", paddingLeft: 0 }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Contact"
                          onChange={(e) => setContact(e.target.value)}
                          value={contact}
                          label="Contact *"
                          error={false}
                        />
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Phone"
                          maxLength={16}
                          onChange={(e) => handlePhoneChange(e.target.value)}
                          value={phone}
                          label="Phone *"
                          error={phoneError}
                          errorText={phoneErrorText}
                        />
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                          label="Email *"
                          error={false}
                        />
                      </Col>
                    </Row>
                    <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "3px" }}>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <DropdownSelect
                          style={{ width: "100%" }}
                          label={"Hardware Recommendation"}
                          value={hardwareSelected || ""}
                          onChange={(e) => {
                            const newHardwareValue = e.target.value;
                            if (!data.vehicle.startsWith("AST")) {
                              const oldHardware = hardwares.find((h) => h.value === hardwareSelected);
                              const newHardware = hardwares.find((h) => h.value === newHardwareValue);

                              if (oldHardware && newHardware && oldHardware.priority !== newHardware.priority) {
                                if (oldHardware.priority !== 1 && reasonSelected && reasonSelected !== "Select Reason") {
                                  reasonForNonPriority1Ref.current = reasonSelected;
                                }
                                if (newHardware.priority !== 1) {
                                  setReasonSelected(reasonForNonPriority1Ref.current || null);
                                } else if (originalFormValues) {
                                  setReasonSelected(originalFormValues.reason);
                                }
                                setIsTableLoading(true);

                                if (materialsAndPriorities && materialsAndPriorities.length > 0) {
                                  const selectedDeviceData = materialsAndPriorities?.find((device) => device.deviceType === newHardware.value);
                                  if (selectedDeviceData && selectedDeviceData.recommendations) {
                                    setTimeout(() => {
                                      setIsTableLoading(false);
                                    }, 1500);
                                  } else {
                                    setIsTableLoading(false);
                                  }
                                } else {
                                  setIsTableLoading(false);
                                }
                              }
                            }
                            setHardwareSelected(newHardwareValue);
                            assignHardwareToHardwareSpecifierMapCreation(vehicleDetails.materialMapping);
                          }}
                          disabled={
                            isLoading ||
                            data.vehicle.startsWith("AST") ||
                            hardwareRequestInitiated ||
                            existingHardwareRequest ||
                            hasNoValidRecommendations()
                          }
                        >
                          {hardwares.map((item) => {
                            return (
                              <option key={item.id} value={item.value} disabled={item.value === "Select"}>
                                {item.label}
                              </option>
                            );
                          })}
                        </DropdownSelect>
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <DropdownSelect
                          style={{ width: "100%" }}
                          label={
                            data.vehicle.startsWith("AST")
                              ? "Reason"
                              : hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1
                              ? "Reason"
                              : "Reason *"
                          }
                          value={reasonSelected || "Select Reason"}
                          onChange={(e) => {
                            setReasonSelected(e.target.value);
                          }}
                          disabled={
                            isLoading ||
                            data.vehicle.startsWith("AST") ||
                            (hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1) ||
                            hardwareRequestInitiated ||
                            existingHardwareRequest ||
                            hasNoValidRecommendations()
                          }
                        >
                          <option disabled>Select Reason</option>
                          {reasons.map((item) => {
                            return (
                              <option key={item.id} value={item.value} disabled={item.value === "Select"}>
                                {item.label}
                              </option>
                            );
                          })}
                        </DropdownSelect>
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <div style={{ fontSize: "0.75rem", fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", color: "black" }}>
                          Priority:{" "}
                          {data.vehicle.startsWith("AST")
                            ? `Recommended`
                            : `${
                                hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1 ? "Recommended" : "Specified"
                              }`}
                        </div>
                        <StyledCheckbox
                          selected={doNotShipCheckboxSelected}
                          role="checkbox"
                          aria-checked={doNotShipCheckboxSelected}
                          type="checkbox"
                          name="default"
                          width="auto"
                          onChange={() => {
                            setDoNotShipCheckboxSelected(!doNotShipCheckboxSelected);
                            setIsDoNotShipChanged(!isDoNotShipChanged);
                          }}
                        >
                          Hold Vehicle
                        </StyledCheckbox>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row
                css={{
                  flexDirection: "row",
                  justifyContent: "start",
                  display: "flex !important",
                  flex: 1,
                  marginTop: "20px",
                }}
              >
                <Col
                  css={{
                    flex: 5,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    paddingLeft: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "visible",
                      width: "1626px",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                          fontSize: "1.1rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          color: "black",
                          ...(existingHardwareRequest ? { width: "865px" } : { flex: 1 }),
                        }}
                      >
                        {`${bundleName} (${bundleId})`}
                      </div>
                      {existingHardwareRequest ? (
                        <div style={{ fontWeight: 700, flex: 1, marginLeft: "11rem" }}>
                          Request# {existingHardwareRequest.id} - {HARDWARE_REQUEST_STATUS[existingHardwareRequest.status]}
                        </div>
                      ) : (
                        <></>
                      )}
                      <div>{renderRequestButtonAndStatus()}</div>
                    </div>

                    {!vehicleDetails.materialMapping.length ? (
                      <div
                        style={{
                          fontSize: "0.8rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          color: "black",
                          padding: "10px 0",
                          fontWeight: "normal",
                        }}
                      >
                        No Material mapping found
                      </div>
                    ) : (
                      <div
                        style={{
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          maxHeight: "900px",
                          fontSize: "0.75rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                          width: "1626px",
                        }}
                      >
                        {isTableLoading && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 10,
                            }}
                          >
                            <Loader active={true} size="medium" />
                          </div>
                        )}

                        <div
                          style={{
                            position: "sticky",
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 2,
                            borderBottom: "1px solid #d8dada",
                            display: "flex",
                          }}
                        >
                          {BUNDLE_LIST.map((column, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "8px 16px",
                                textAlign: "left",
                                fontWeight: "700",
                                fontSize: "0.75rem",
                                color: "#6F7171",
                                flex: column.width || 1,
                                overflow: "visible",
                                boxSizing: "border-box",
                                height: "auto",
                                wordBreak: "break-word",
                              }}
                            >
                              {column.key}
                            </div>
                          ))}
                        </div>
                        <div
                          style={{
                            overflowY: "auto",
                            flex: 1,
                            minHeight: 0,
                          }}
                        >
                          {subscriptionTableBody.map((rowData, index) => {
                            const { type, subscriptionId, subscriptionName, techRefId } = rowData;

                            return (
                              <div
                                key={subscriptionId}
                                style={{
                                  display: "flex",
                                  borderBottom: "1px solid #eee",
                                  backgroundColor: type.toLowerCase() === "core" ? "#E3F2FD" : index % 2 === 0 ? "#F6F6F6" : "#D8DADA",
                                }}
                              >
                                <div
                                  key={0}
                                  style={{
                                    padding: "16px",
                                    fontSize: "0.75rem",
                                    flex: 0.27,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {type && type !== "--" ? (
                                    <span style={{ padding: "2px 4px", borderRadius: "2px", fontWeight: 700, ...BADGE_STYLE[type.toLowerCase()] }}>
                                      {type}
                                    </span>
                                  ) : (
                                    "--"
                                  )}
                                </div>
                                <div
                                  key={1}
                                  style={{
                                    padding: "16px",
                                    fontSize: "0.75rem",
                                    flex: 0.7,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {subscriptionName ? (
                                    <>
                                      <div style={{ color: "black", fontWeight: 700 }}>{subscriptionName}</div>
                                      <div style={{ color: "#6F7171", paddingTop: "4px", fontSize: "11px" }}>Subscription ID: {subscriptionId}</div>
                                      <div style={{ color: "#6F7171", paddingTop: "4px", fontSize: "11px" }}>
                                        Tech Ref: {techRefId ? techRefId.replace(".", "-") : techRefId}
                                      </div>
                                    </>
                                  ) : (
                                    "—"
                                  )}
                                </div>
                                <div
                                  key={7}
                                  style={{
                                    color: "black",
                                    flex: 0.4,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderDontShipCheckBox(rowData)}
                                </div>
                                <div
                                  key={2}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.7,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderHardwareDetails(rowData)}
                                </div>
                                <div
                                  key={3}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.7,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderHardwareSpecifier(rowData)}
                                </div>
                                <div
                                  key={4}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.2,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderLineType(rowData)}
                                </div>
                                <div
                                  key={5}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.8,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderRequestedHardware(rowData)}
                                </div>
                                <div
                                  key={6}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.8,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderApprovedChanges(rowData)}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              {hardwareRequestInitiated ? (
                <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex", flex: 1, marginTop: "8px" }}>
                  <Col css={{ flex: 1 }}>
                    <div style={{ display: "flex", flexDirection: "row", width: "1626px", justifyContent: "flex-end" }}>
                      <div style={{ flex: 0.2 }}></div>
                      <div style={{ flex: 0.5 }}></div>
                      <div style={{ flex: 1 }}></div>
                      <div style={{ flex: 0.8 }}>
                        {/* disable when req already made and no recommendation */}

                        <div
                          style={{
                            fontWeight: 700,
                            textDecoration: "underline",
                            fontSize: "12px",
                            ...(existingHardwareRequest ? { pointerEvents: "none", opacity: 0.6 } : { cursor: "pointer" }),
                          }}
                          tabIndex={existingHardwareRequest ? -1 : 0}
                          aria-disabled={!!existingHardwareRequest}
                          onClick={() => {
                            if (!existingHardwareRequest) setIsAddMaterialModalOpen(true);
                          }}
                        >
                          Add Material
                        </div>

                        <div style={{ marginTop: "16px", width: "328px", fontFamily: "Verizon-NHG-eTX" }}>
                          {existingHardwareRequest ? (
                            <>
                              <label>Reason for Changing*</label>
                              <div style={{ height: "44px", border: "1px solid #D8DADA", borderRadius: "4px", padding: "12px" }}>
                                {reasonForChangingRecommendation}
                              </div>
                            </>
                          ) : (
                            <DropdownSelect
                              style={{ width: "100%" }}
                              label={"Reason for Changing*"}
                              value={reasonForChangingRecommendation || "Select Reason"}
                              onChange={(e) => {
                                setReasonForChangingRecommendation(e.target.value);
                              }}
                              disabled={isLoading || isTableLoading || !isRequestedHardwareChanged} // enable when there is change in requested hardware
                            >
                              <option disabled>Select Reason</option>
                              {reasons.map((item) => {
                                return (
                                  <option key={item.id} value={item.labels} disabled={item.value === "Select"}>
                                    {item.label}
                                  </option>
                                );
                              })}
                            </DropdownSelect>
                          )}
                        </div>

                        <div style={{ marginTop: "8px", width: "328px", fontFamily: "Verizon-NHG-eTX" }}>
                          {/* add disable logic and set field afetr api call */}
                          {existingHardwareRequest ? (
                            <>
                              <label>Comments*</label>
                              <div style={{ height: "88px", border: "1px solid #D8DADA", borderRadius: "4px", padding: "12px" }}>
                                {hardwareChangeComment}
                              </div>
                            </>
                          ) : (
                            <TextArea
                              label="Comments*"
                              aria-label="Comments*"
                              required={true}
                              maxLength={200}
                              value={hardwareChangeComment}
                              onChange={(e) => setHardwareChangeComment(e.target.value)}
                              css={{
                                fontSize: "12px",
                                fontFamily: "Verizon-NHG-eTX",
                                letterSpacing: "0",
                              }}
                              disabled={isLoading || isTableLoading || !isRequestedHardwareChanged} // enable when there is change in requested hardware
                            />
                          )}
                        </div>
                        <div style={{ marginTop: "8px", fontSize: "12px", fontFamily: "Verizon-NHG-eTX" }}>
                          If you have a backup documentation, then use attachment below.
                        </div>
                      </div>
                      <div style={{ flex: 0.8 }}>
                        {/* show approval comment only once the request has reached final state */}
                        {existingHardwareRequest?.approvalComments && existingHardwareRequest.approvalComments !== "" ? (
                          <div style={{ fontWeight: 700, paddingBottom: "8px", fontSize: "12px" }}>
                            Comments: {existingHardwareRequest.approvalComments}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div
                          style={{
                            marginTop: "8px",
                            display: "flex",
                          }}
                        >
                          <Button
                            role="button"
                            size="small"
                            variant="primary"
                            aria-label="Accept Hardware"
                            data-testid="accept-hardware-button"
                            disabled={existingHardwareRequest ? ![MODIFIED_PENDING_AGENT].includes(existingHardwareRequest.status) : true} // enable once req status is pending agent
                            aria-disabled={true}
                            primary
                            onClick={() => updateHardwareRequestHandler("USER_ACCEPT")}
                          >
                            Accept Hardware
                          </Button>
                          <Button
                            style={{ marginLeft: "0.5rem" }}
                            role="button"
                            size="small"
                            aria-label="Use Hardware Specifier"
                            data-testid="use-current-recommendation-button"
                            disabled={
                              existingHardwareRequest && !hasNoValidRecommendations()
                                ? ![MODIFIED_PENDING_AGENT, REVERTED_PENDING_AGENT].includes(existingHardwareRequest.status)
                                : true
                            } // enable once the req is in pending Agent state
                            aria-disabled={true}
                            secondary
                            onClick={() => updateHardwareRequestHandler("USER_USE_HARDWARE_SPECIFIER")}
                          >
                            Use Hardware Specifier
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Grid>

            <div>
              <VehicleImageUpload
                onImagesChange={handleFileUpload}
                onFileUpload={handleFileUpload}
                vehicleId={data.vehicle}
                bundleId={bundleId}
                setIsLoading={setIsLoading}
                showCustomAlert={notify}
                RETRIEVE_BASE_URL={retrieveBundleFiles}
              />
            </div>
          </>
        )}
        {isAddMaterialModalOpen && (
          <AddMaterial
            isOpen={isAddMaterialModalOpen}
            onClose={() => {
              setIsAddMaterialModalOpen(false);
            }}
            recommendations={vehicleDetails.materialMapping} //filter already selected requested hardwares
            handleAddMaterial={(addedMaterials) => {
              setAddedMaterials(addedMaterials);
            }}
            addedMaterials={addedMaterials}
            existingHardwareMap={existingHardwareMap}
            materialList={requestedMaterialList}
          />
        )}
        {showClearRequestModal && (
          <ClearRequestConfirmationModal
            showClearRequestModal={showClearRequestModal}
            setShowClearRequestModal={setShowClearRequestModal}
            handleClearRequest={handleClearRequest}
          />
        )}
        {showChangeVehicleModal && (
          <VehicleChangeModal
            showChangeVehicleModal={showChangeVehicleModal}
            setShowChangeVehicleModal={setShowChangeVehicleModal}
            data={vehicleDetails}
            bundleName={bundleName}
            handleConfirmChange={handleChangeVehicle}
          />
        )}
      </div>
    </>
  );
};
export default EditVehicleWTAComponent;
